export function readCsrf(): string | null {
  if (typeof document === 'undefined') return null;
  for (const part of document.cookie.split(';')) {
    const [name, ...rest] = part.trim().split('=');
    if (name === 'csrf') return decodeURIComponent(rest.join('='));
  }
  return null;
}
